import { formatISO } from "date-fns";
import { AttributeType } from "@evergis/api";

import { isNumeric } from "../../../utils/string";
import { isEmptyValue } from "./isEmptyValue";
import { SelectedFilter } from "../types";

const NUMERIC_TYPES = [AttributeType.Double, AttributeType.Int32, AttributeType.Int64];

const checkIsDateFormat = (value: string) => value.startsWith("#'") && value.endsWith("'");

const checkIfNeedQuotes = (value?: string | number, attributeType?: AttributeType) => {
  return attributeType
    ? !NUMERIC_TYPES.includes(attributeType)
    : typeof value === "number"
    ? false
    : typeof value === "string" && !isNumeric(value) && !checkIsDateFormat(value);
};

export const formatConditionValue = ({
  value,
  attributeType,
  checkQuotes = true,
  isSetParams = false,
}: {
  value?: SelectedFilter["value"];
  attributeType?: AttributeType;
  checkQuotes?: boolean;
  isSetParams?: boolean;
}): string => {
  if (isEmptyValue(value)) return "";

  const isArray = Array.isArray(value);
  let stringValue = value instanceof Date ? formatISO(value) : value.toString();

  if (isArray) {
    return (value as string[]).length && !(value as string[]).every(item => !item)
      ? `[${(value as string[])
          .map(item => (checkQuotes && checkIfNeedQuotes(item, attributeType) ? `'${item}'` : item))
          .join(",")}]`
      : "";
  }

  if (isSetParams && checkIsDateFormat(stringValue)) {
    stringValue = stringValue.slice(2, -1);
  }

  return checkQuotes && checkIfNeedQuotes(stringValue, attributeType) ? `'${stringValue}'` : stringValue;
};
